/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Shortcut_Keys_Name_Toggle_PlaybackInputs */



/**
* | output |
* | --- |
* | "Toggle Playback (Play/Pause)" |
*
* @param {Shortcut_Keys_Name_Toggle_PlaybackInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const shortcut_keys_name_toggle_playback = /** @type {((inputs?: Shortcut_Keys_Name_Toggle_PlaybackInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shortcut_Keys_Name_Toggle_PlaybackInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Basculer lecture (lecture/pause)")
	if (locale === "de") return /** @type {LocalizedString} */ ("Wiedergabe umschalten (Wiedergabe/Pause)")
	if (locale === "it") return /** @type {LocalizedString} */ ("Attiva/disattiva la riproduzione (Riproduci/Pausa)")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Переключить воспроизведение (Воспроизведение/Пауза)")
	if (locale === "es") return /** @type {LocalizedString} */ ("Alternar reproducción (Reproducir/Pausa)")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("切换播放（播放/暂停）")
	if (locale === "ja") return /** @type {LocalizedString} */ ("再生の切り替え（再生/一時停止）")
	if (locale === "hi") return /** @type {LocalizedString} */ ("प्लेबैक टॉगल करें (चलाएँ/रोकें)")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Alternar reprodução (Reproduzir/Pausar)")
	return /** @type {LocalizedString} */ ("Toggle Playback (Play/Pause)")
});